// extracted by mini-css-extract-plugin
module.exports = {"loading":"PageLoading_loading__36-nk","loadingShrink":"PageLoading_loadingShrink__2Q6Vs"};